import { create } from 'zustand'
import { STATIC_ACCESS_TOKEN } from '@/config/settings'

// A reactive "there is a usable token" signal, so the app's STARTUP is decoupled from the JWT
// refresh (block 7). Public mode (a baked-in static token) starts at `true`, so the data surfaces
// (exclusion tiles, catalogues) request from the very first render, exactly as before (no
// regression). Login mode starts at `false` and the <Auth> provider sets it to `true` once the
// session JWT is CONFIRMED, so catalogues and tiles neither fire with an empty Bearer (401) nor pin
// an empty token into their source (the latent bug of `[]` deps in exclusion-layer). See
// auth/provider.tsx.
interface TokenState {
  ready: boolean
  setReady: (ready: boolean) => void
  // Bumped by auth.ts on every WRITE of the session JWT (login and each silent refresh). `ready`
  // alone cannot signal a refresh — it is already true — and a refreshed token can carry a
  // DIFFERENT roles claim, which readers like `useUserRole` must recompute rather than keep the
  // profile the old token proved.
  tokenVersion: number
  bumpTokenVersion: () => void
}

export const useTokenStore = create<TokenState>((set) => ({
  ready: Boolean(STATIC_ACCESS_TOKEN),
  setReady: (ready) => set({ ready }),
  tokenVersion: 0,
  bumpTokenVersion: () =>
    set((state) => ({ tokenVersion: state.tokenVersion + 1 })),
}))
